import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {BasketPageService_ApplyCouponLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {
  useBasketItemForProduct,
  useFullSession,
  useIsBasketStateLoaded,
} from '@aboutyou/user';
import {useCallback, useEffect, useRef, useState} from 'react';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useReductionsStateRequestParameter} from '../../ReductionsState/useReductionsStateRequestParameter';

export const useRetroactivelyApplyCouponToProduct = ({
  productId,
}: {
  productId?: number;
}) => {
  const appliedOnce = useRef(false);
  const basketItemForProduct = useBasketItemForProduct(productId);
  const session = useFullSession();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const isBasketStateLoaded = useIsBasketStateLoaded();
  const reductionsState = useReductionsStateRequestParameter();
  const [couponPromotionIdToUnlock, setCouponPromotionIdToUnlock] = useState<
    string | undefined
  >();

  const applyCouponCallback = useGrpcRequestMutation(
    BasketPageService_ApplyCouponLazy,
  );

  useEffect(() => {
    if (appliedOnce.current) return;

    if (
      !couponPromotionIdToUnlock ||
      !isBasketStateLoaded ||
      !basketItemForProduct
    ) {
      return;
    }

    const basketItemAlreadyHasCouponApplied =
      basketItemForProduct.appliedCouponPromotionId;

    // if the basket item already has a coupon applied, we should not override that
    if (basketItemAlreadyHasCouponApplied) {
      return;
    }

    applyCouponCallback.mutateAsync({
      session: session!,
      targetGroup: targetGroupIdentifier,
      couponPromotionId: couponPromotionIdToUnlock,
      itemKey: basketItemForProduct.itemKey,
      reductionsState,
    });

    appliedOnce.current = true;
  }, [
    applyCouponCallback,
    basketItemForProduct,
    couponPromotionIdToUnlock,
    isBasketStateLoaded,
    session,
    targetGroupIdentifier,
    reductionsState,
  ]);

  return useCallback(({couponPromotionId}: {couponPromotionId: string}) => {
    setCouponPromotionIdToUnlock(couponPromotionId);
  }, []);
};
